(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-remove-confirm"] && !Shopify.designMode) return;
  try {
    // Resolves true when the visitor confirms the removal. Cancel, Escape and
// a click outside the box resolve false. Focus is kept on the two buttons
// while the box is open and returned to the trigger afterwards.
window.confirmCartRemove = function (box) {
  if (typeof box.showPopover !== 'function') {
    var text = box.querySelector('[data-confirm-text]');
    return Promise.resolve(window.confirm(text ? text.textContent.trim() : ''));
  }

  return new Promise(function (resolve) {
    var trigger = document.activeElement;
    var cancelBtn = box.querySelector('[data-confirm-cancel]');
    var removeBtn = box.querySelector('[data-confirm-remove]');

    var done = function (confirmed) {
      document.removeEventListener('click', onDocumentClick, true);
      document.removeEventListener('keydown', onKeydown, true);
      if (box.matches(':popover-open')) box.hidePopover();
      box.hidden = true;
      if (trigger && document.contains(trigger) && typeof trigger.focus === 'function') trigger.focus();
      resolve(confirmed);
    };

    // The backdrop is not hit-testable, so a click outside the box lands
    // on whatever is behind it (the drawer, the page). Swallow it.
    var onDocumentClick = function (e) {
      if (box.contains(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      done(false);
    };

    var onKeydown = function (e) {
      if (e.key === 'Escape') {
        // Only the box closes, not the drawer behind it.
        e.preventDefault();
        e.stopPropagation();
        done(false);
      } else if (e.key === 'Tab') {
        var active = document.activeElement;
        if (!box.contains(active) || (e.shiftKey && active === cancelBtn)) {
          e.preventDefault();
          (e.shiftKey ? removeBtn : cancelBtn).focus();
        } else if (!e.shiftKey && active === removeBtn) {
          e.preventDefault();
          cancelBtn.focus();
        }
      }
    };

    cancelBtn.onclick = function () { done(false); };
    removeBtn.onclick = function () { done(true); };

    box.hidden = false;
    box.showPopover();
    cancelBtn.focus();

    // Listen from the next task so the click that opened the box is not
    // taken for an outside click.
    setTimeout(function () {
      document.addEventListener('click', onDocumentClick, true);
      document.addEventListener('keydown', onKeydown, true);
    }, 0);
  });
};
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-card"] && !Shopify.designMode) return;
  try {
    /* Without JS the form falls back to a normal POST to the cart. */
document.addEventListener('submit', async function (e) {
  var form = e.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.hasAttribute('data-card-form')) return;

  e.preventDefault();

  var btn = form.querySelector('button[type="submit"]');
  if (btn) btn.disabled = true;

  try {
    var addRes = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
    if (!addRes.ok) throw new Error('cart/add status ' + addRes.status);

    var cartRes = await fetch('/cart.js');
    var cart = await cartRes.json();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  } catch (err) {
    console.error('Card add-to-cart failed:', err);
  } finally {
    if (btn) btn.disabled = false;
  }
}, true);
  } catch(e) { console.error(e); }
})();

})();
